import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { DatePipe } from '@angular/common';
import { EncrDecrService } from './../../services/encr-decr.service';
import { SoaImageService } from './../../services/soa-image.service';
import { ContactService } from './../../services/contact.service';
import { FactoringInvoiceService } from './../../services/factoring-invoice.service';

@Component({
    selector: 'app-email-files-factoring',
    templateUrl: './email-files-factoring.component.html',
    styleUrls: ['./email-files-factoring.component.css']
})

export class EmailFilesFactoringComponent implements OnInit {
    user_id: any = '';
    folderid: any = '';
    company_id: any = '';
    APIKEY: any = '';
    emailModel: any = {};
    validFolder: boolean = false;
    btnDisable: boolean = false;
    pdfSrc: string = '';
    loaderMode: boolean = false;
    loaderMessage: boolean = false;
    rfolderid: any = 0;
    folder_id_e: any = 0;
    customer_id: any = 0;
    nonfactmode: any = 1;
    mergeStatus: boolean = false;
    mergeActionStatus: boolean = false;
    // added by archana on 21/07/2023 for sent to factor
    model: any = { customer_name: '', invoice: '', date_invoice: '', terms: '', amount: '', reference_number: '', po_number: '', work_week: '', load_number: '', mode: 'add', sub_total: '', Tax_amount: '' };
    factInvoiceMode: any = 'add';
    fact_invoice_id: any = 0;
    // end
    /*code by 28feb*/
    assign_fact_check_css: any = 'block';
    constructor(private _router: Router,
        private toastr: ToastrService,
        private _activatedroute: ActivatedRoute,
        private fb: FormBuilder,
        private http: HttpClient,
        private EncrDecr: EncrDecrService,
        private _soaImage: SoaImageService,
        private _contact: ContactService,
        private datePipe: DatePipe,
        private _factInvoice: FactoringInvoiceService,
    ) { }

    ngOnInit() {
        this.user_id = localStorage.getItem('id');
        this.company_id = localStorage.getItem('company_id');
        this.APIKEY = localStorage.getItem('APIKEY');

        this._activatedroute.params.subscribe(params => {
            this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
            this.folder_id_e = params['id'];
        });
        //added and updated by archana on 21/07/2023 
        this.updateCheckInvoice(this.folderid);
        this.getFolderInfo(this.folderid);
        // end
    }


    getFolderInfo(folderid) {
        this.loaderMode = true;
        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            mobile_id: folderid,
        }

        this.rfolderid = this.EncrDecr.set(localStorage.getItem('key'), folderid);
        this._soaImage.getFolderInfo(folderModel).subscribe(
            res => {
                // console.log('res ', res.data);
                // console.log('merge_pdf_path ', res.data.merge_pdf_path);
                this.pdfSrc = res.data.merge_pdf_path;

                this.loaderMode = false;
                if (res.data.assign_fact == '1' || res.data.assign_fact == '2') {
                    this.nonfactmode = 0;
                }
                this.customer_id = res.data.customer_id;
                if (res.data.merge_pdf_path != '') {
                    this.mergeStatus = true;
                    this.mergeActionStatus = true;
                }
                //if (res.data.soa_email == 'No' && res.data.merge_pdf_path != '') {
                this.getCustomerEmail();
                //}
            },
        );
    }

    getCustomerEmail() {
        this.loaderMode = true;
        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            customer_id: this.customer_id,
        }

        this._contact.getContactEmailsByid(folderModel).subscribe(
            res => {
                this.loaderMode = false;
                if (res.data.assign_fact == '3') {
                    this.assign_fact_check_css = 'none';
                }

                //console.log(res.data.assign_fact);
                this.emailModel = res.data;
            },
        );
    }


    onSubmitInfo() {
        this.loaderMode = true;
        this.loaderMessage = true;
        this.btnDisable = true;

        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            email_info: this.emailModel,
            folder_id: this.folderid,
        }
        // console.log(folderModel);
        this._soaImage.sendEmailToCustomer(folderModel).subscribe(
            res => {
                this.loaderMode = false;
                this.loaderMessage = false;
                if (res.status == true) {
                    this.toastr.success(res.message, 'Success');
                    if (folderModel.email_info.assign_fact == '3') {
                        this._router.navigateByUrl('/mobile/mobile-list');
                    }
                    else {
                        // added by archana and commented on 21/07/2023
                        this.onSubmitFolder('no');
                        // this._router.navigateByUrl('/mobile/factoring-invoice/' + this.folder_id_e);
                    }
                } else {
                    this.btnDisable = false;
                    this.toastr.error(res.message, 'Error');
                    //this._router.navigateByUrl('/mobile/factoring-invoice/' + this.folder_id_e);
                }
            },
        );




    }

    omit_special_char(event) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        //alert(k);
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || k == 45 || (k >= 48 && k <= 57));
    }
    omits_special_char(event) {
        var k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        return (k == 8 || k == 32 || (k >= 48 && k <= 57));
    }

    isNumberKey(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;

        return true;
    }

    // added by archana 21/07/2023 
    onSubmitFolder(status = 'no') {
        this.btnDisable = true;
        this.model['APIKEY'] = this.APIKEY;
        this.model['user_id'] = this.user_id;
        this.model['company_id'] = this.company_id;
        this.model['folder_id'] = this.folderid;
        this.model['invoice_mode'] = this.factInvoiceMode;
        this.model['invoice_id'] = this.fact_invoice_id;
        this.model['date_invoice'] = this.datePipe.transform(this.model['date_invoice'], 'MM/dd/yyyy, hh:mm a');
        this.model['work_week'] = this.datePipe.transform(this.model['work_week'], 'MM/dd/yyyy, hh:mm a');
        this._factInvoice.factInvoiceSave(this.model).subscribe(
            res => {
                //status 'No' means form me kuch change nahi kiya hai
                if (status == 'no') {
                    this.toastr.success(res.message, 'Success');
                    this._router.navigateByUrl('/redirect').then(() => {
                        //this._router.navigateByUrl('/mobile/mobile-list');
                        this._router.navigateByUrl('/factoring/factoring-tab1');
                    });
                }
            },
        );
    }
    // added by archana on 21/07/2023 
    updateCheckInvoice(folderid) {
        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            mobile_id: folderid,
        }
        this._factInvoice.updateCheckfact(folderModel)
            .subscribe(
                res => {
                    if (res.status == true) {
                        this.factInvoiceMode = 'edit';
                        this.fact_invoice_id = res.data[0].id;
                    }
                    this.getFolderInfoforfactoring(this.folderid);
                },
            );
    }

    getFolderInfoforfactoring(folderid) {
        this.loaderMode = true;
        const folderModel = {
            APIKEY: this.APIKEY,
            user_id: this.user_id,
            company_id: this.company_id,
            mobile_id: folderid,
        }
        this.rfolderid = this.EncrDecr.set(localStorage.getItem('key'), folderid)
        this._factInvoice.getFolderInfo(folderModel)
            .subscribe(
                res => {
                    this.model = res.data;
                    //invoice number and amount By Archana
                    this.model['sub_total'] = res.data.sub_total_inv;
                    this.model['tax_amount'] = res.data.inv_tax_amount;
                    if (res.data.invoice_number_item) {
                        this.model['invoice_number'] = res.data.invoice_number_item;
                        this.model['amount'] = res.data.grand_total_inv;
                        //INV2000
                    }
                    else {
                        this.model['amount'] = res.data.amt;
                        //121
                    }
                    //invoice number and amount By Archana
                    this.pdfSrc = res.data.merge_pdf_path;
                    if (res.data.inv_created_date == null) {
                        this.model['date_invoice'] = ''; //this.datePipe.transform(dateInvoice, 'MM/dd/yyyy');
                    }
                    else {
                        var di = res.data.inv_created_date;
                        di = di.toString().replace(/-/g, "/");
                        di = new Date(di);
                        this.model['date_invoice'] = this.datePipe.transform(di, 'MM/dd/yyyy');
                    }
                    if (this.model['work_week'] == null) {
                        this.model['work_week'] = '';
                    }
                    else {
                        var ww = this.model['work_week'];
                        ww = ww.toString().replace(/-/g, "/");
                        ww = new Date(ww);
                        this.model['work_week'] = this.datePipe.transform(ww, 'MM/dd/yyyy');
                    }
                    //invoice date By Archana
                    if (this.factInvoiceMode != 'add') {
                        this.model['terms'] = res.data.factterms;
                    }
                    this.loaderMode = false;
                },
            );
    }


}